<template>
    <div class="overflow-x-auto">
        <table class="w-full text-sm">
            <thead>
                <tr class="border-b border-gray-200 dark:border-zinc-600">
                    <th class="py-2 pr-3 text-left text-xs font-medium text-gray-500 dark:text-zinc-400">
                        {{ lang('invoices::analysis.fields.item_name') }}
                    </th>
                    <th class="py-2 pr-3 text-right text-xs font-medium text-gray-500 dark:text-zinc-400 w-16">
                        {{ lang('invoices::analysis.fields.quantity') }}
                    </th>
                    <th class="py-2 pr-3 text-right text-xs font-medium text-gray-500 dark:text-zinc-400 w-24">
                        {{ lang('invoices::analysis.fields.price') }}
                    </th>
                    <th class="py-2 pr-3 text-right text-xs font-medium text-gray-500 dark:text-zinc-400 w-16">
                        {{ lang('invoices::analysis.fields.vat_rate') }}
                    </th>
                    <th class="py-2 text-right text-xs font-medium text-gray-500 dark:text-zinc-400 w-24">
                        {{ lang('invoices::analysis.fields.price_vat') }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(item, idx) in items"
                    :key="idx"
                    class="border-b border-gray-100 dark:border-zinc-700"
                >
                    <td class="py-2 pr-3 text-gray-900 dark:text-zinc-100">
                        <template v-if="editable">
                            <input
                                v-model="localItems[idx].name"
                                type="text"
                                class="forms__input text-xs w-full"
                                @input="emitUpdate"
                            />
                        </template>
                        <template v-else>{{ item.name }}</template>
                    </td>
                    <td class="py-2 pr-3 text-right text-gray-900 dark:text-zinc-100">
                        <template v-if="editable">
                            <input
                                v-model.number="localItems[idx].quantity"
                                type="number"
                                min="1"
                                class="forms__input text-xs w-16 text-right"
                                @input="emitUpdate"
                            />
                        </template>
                        <template v-else>{{ item.quantity }}</template>
                    </td>
                    <td class="py-2 pr-3 text-right text-gray-900 dark:text-zinc-100">
                        <template v-if="editable">
                            <input
                                v-model.number="localItems[idx].price"
                                type="number"
                                class="forms__input text-xs w-24 text-right"
                                @input="emitUpdate"
                            />
                        </template>
                        <template v-else>{{ item.price }}</template>
                    </td>
                    <td class="py-2 pr-3 text-right text-gray-900 dark:text-zinc-100">
                        <template v-if="editable">
                            <input
                                v-model.number="localItems[idx].vatRate"
                                type="number"
                                class="forms__input text-xs w-16 text-right"
                                @input="emitUpdate"
                            />
                        </template>
                        <template v-else>{{ item.vatRate }}%</template>
                    </td>
                    <td class="py-2 text-right font-medium text-gray-900 dark:text-zinc-100">
                        <template v-if="editable">
                            <input
                                v-model.number="localItems[idx].priceVat"
                                type="number"
                                class="forms__input text-xs w-24 text-right"
                                @input="emitUpdate"
                            />
                        </template>
                        <template v-else>{{ item.priceVat }}</template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script lang="ts" setup>
import { reactive, watch } from 'vue';
import { lang } from '@/lang/composable';

interface InvoiceItem {
    name: string;
    quantity: number;
    price: number;
    priceVat: number;
    vatRate: number;
    description?: string;
}

const props = withDefaults(defineProps<{
    items: InvoiceItem[];
    editable?: boolean;
}>(), {
    editable: false,
});

const emit = defineEmits<{
    'update:items': [items: InvoiceItem[]];
}>();

const localItems = reactive([...props.items.map(i => ({ ...i }))]);

watch(() => props.items, (newItems) => {
    localItems.splice(0, localItems.length, ...newItems.map(i => ({ ...i })));
}, { deep: true });

const emitUpdate = () => {
    emit('update:items', [...localItems]);
};
</script>
